import React from "react";

// Mui Styles
import {
  productDiscountTheme,
  productDiscounTableRowTheme,
} from "../styles/mui/tableListTheme";
// import { styled } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
// Mui
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { StyledPaper } from "../styles/mui/globalStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Menu from "@mui/material/Menu";
import LoadingButton from "@mui/lab/LoadingButton";

import {
  getProductDiscount,
  getProductDiscountRemark,
  updateProductDiscountRemark,
} from "@/fetch/fetchProduct";

import { getProducts } from "@/fetch/fetchStatistics";

import { ProductSelection } from "@/components/Filter/productSelection";

//import redux source
import { useSelector } from "react-redux";
import {
  setSelectedBrand,
  setSelectedProduct,
} from "@/features/dataTableSlice";

//lodash
import _ from "lodash";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "../components/layout";
import Title from "../components/title";

import moment from "moment";
import "moment/locale/zh-hk";

//redux

const ProductDiscountPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();

  //import redux state storage
  const selectedBrand = useSelector((state) => state.dataTable.selectedBrand);
  const selectedProduct = useSelector(
    (state) => state.dataTable.selectedProduct
  );

  moment.updateLocale("zh-hk", {
    week: {
      dow: 5,
    },
  });

  const emptyValue = Array(10).fill({
    product_master_id: "",
    product_name: "",
    id: 0,
    unit_price: "",
    discount_datetime: "",
    discount_details: [],
  });
  const initalYear = 2021;
  const length = moment().diff(moment(initalYear, "YYYY"), "year") + 1;
  const rangeYear = Array.from({ length }, (_, index) =>
    moment().subtract(index, "year").format("YYYY")
  );

  const [product, setProduct] = React.useState(emptyValue);
  const [productData, setProductData] = React.useState([]);

  const [isLoading, setLoading] = React.useState(false);
  const [productRemark, setProductRemark] = React.useState([]);
  const [selectedYear, setSelectedYear] = React.useState(
    moment().format("YYYY")
  );
  const [currentYear, setCurrentDate] = React.useState(selectedYear);
  const [year, setYear] = React.useState(
    Array.from(
      { length: moment(selectedYear).weeksInYear() + 1 },
      (_, index) => index
    )
  );

  const fetchData = async (startYear, endYear) => {
    const reply = await getProductDiscount(
      startYear,
      endYear,
      selectedProduct,
      selectedBrand
    );
    if (reply.results && reply.data) {
      setProduct(reply.data);
    } else {
      setProduct(emptyValue);
    }

    const replyRemark = await getProductDiscountRemark(selectedYear);
    if (replyRemark.results && replyRemark.data) {
      setProductRemark(replyRemark.data);
    }
  };

  const fetchAll = async () => {
    setLoading(true);
    setProduct(emptyValue);
    const startYear = moment(`${selectedYear}-1`, "YYYY-w")
      .startOf("week")
      .format("YYYY-MM-DD");
    const endYear = moment(
      `${selectedYear}-${moment(selectedYear).weeksInYear()}`,
      "YYYY-w"
    )
      .endOf("week")
      .format("YYYY-MM-DD");
    setCurrentDate(selectedYear);
    const year = Array.from(
      { length: moment(selectedYear).weeksInYear() + 1 },
      (_, index) => index
    );
    setYear(year);
    await fetchData(startYear, endYear);
    setLoading(false);
  };

  const remarkItemProps = {
    fetchData,
    selectedYear,
  };
  const fetchProduct = async () => {
    const { data } = await getProducts();
    setProductData(data);
  };
  React.useEffect(() => {
    fetchProduct();
  }, []);
  return (
    <Layout
      header="CustomerDailyPage"
      selectedIndex={24}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`推廣記錄`} history={() => navigate(-1)} />
      <StyledPaper page={"yes"}>
        <Box width={"100%"}>
          <ProductSelection
            selectedBrand={selectedBrand}
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            setSelectedBrand={setSelectedBrand}
            productData={productData}
          />
          <FormControl sx={{ m: 1, width: 100 }}>
            <InputLabel id="brand-select-label">年份</InputLabel>
            <Select
              labelId="brand-select-label"
              id="brand-select"
              value={moment(selectedYear).format("YYYY")}
              label="brand"
              onChange={(event) => {
                setSelectedYear(event.target.value);
              }}
            >
              {rangeYear.map((year, index) => (
                <MenuItem key={index} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, mt: 2.5 }}>
            <LoadingButton
              onClick={fetchAll}
              size="small"
              loading={isLoading}
              loadingIndicator="Loading…"
              variant="contained"
              color="success"
            >
              Search
            </LoadingButton>
          </FormControl>
        </Box>
        <ProductTable
          product={product}
          year={year}
          currentYear={currentYear}
          productRemark={productRemark}
          remarkItemProps={remarkItemProps}
        />
      </StyledPaper>
    </Layout>
  );
};

export default ProductDiscountPage;
const ProductTable = React.memo(function ProductTable({
  product,
  year,
  currentYear,
  productRemark,
  remarkItemProps,
}) {
  return (
    <ThemeProvider theme={productDiscountTheme}>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableBody>
            <ThemeProvider theme={productDiscounTableRowTheme}>
              <TableRow>
                {year.map((x) => {
                  const startDate = (x) =>
                    moment(`${currentYear}-${x}`, "YYYY-w")
                      .startOf("week")
                      .format("DD/MM/YYYY");
                  const endDate = (x) =>
                    moment(`${currentYear}-${x}`, "YYYY-w")
                      .endOf("week")
                      .format("DD/MM/YYYY");
                  return (
                    <TableCell
                      key={x}
                      sx={{
                        borderLeft: x === 0 && "1px solid rgb(224, 224, 224)",
                        borderRight: x === 0 && `1px solid black`,
                        position: x === 0 && "sticky",
                        left: x === 0 && 0,
                        backgroundColor: x === 0 && "white",
                      }}
                      align={"center"}
                    >
                      {x > 0 ? (
                        <>
                          <div>
                            Week
                            {("0" + x).substring(
                              ("0" + x).length - 2,
                              ("0" + x).length
                            )}
                          </div>
                          <div>
                            {startDate(x)} - {endDate(x)}
                          </div>
                        </>
                      ) : (
                        "Product Name"
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </ThemeProvider>
            {product.map((parentItem, index) => {
              return (
                <ProductTableCell
                  key={index}
                  parentItem={parentItem}
                  index={index}
                  product={product}
                  year={year}
                  currentYear={currentYear}
                  productRemark={productRemark}
                  remarkItemProps={remarkItemProps}
                ></ProductTableCell>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
},
_.isEqual);
const ProductTableCell = React.memo(function ProductTableCell({
  parentItem,
  index,
  year,
  currentYear,
  productRemark,
  remarkItemProps,
}) {
  return (
    <TableRow key={index}>
      {year.map((x) => {
        let target;

        const remark = productRemark.find(
          (remark) =>
            remark.remark_week === x &&
            remark.product_master_id === parentItem.product_master_id &&
            remark.remark_year === moment(currentYear).format("YYYY")
        );

        if (x > 0) {
          target = parentItem.discount_details
            .filter(
              (insideValue) =>
                insideValue.period?.includes(x) &&
                parseInt(insideValue.product_discount_price) &&
                parseInt(insideValue.product_discount_price) !==
                  parseInt(parentItem.unit_price)
            )
            .sort(
              (a, b) =>
                moment(a.product_discount_startdate) -
                moment(b.product_discount_startdate)
            );

          target = _.uniqBy(target, "product_discount_startdate");
        }

        return (
          <TableCell
            onClick={(event) => event.target.firstElementChild?.click()}
            key={x}
            sx={{
              borderLeft: `1px solid rgb(224, 224, 224)`,
              borderRight: x === 0 && `1px solid black`,
              backgroundColor: target?.length > 0 ? "yellow" : "white",
              position: x === 0 && "sticky",
              left: x === 0 && 0,
              verticalAlign: x > 0 && "top",
            }}
            align={x > 0 ? "center" : "left"}
          >
            <RemarkItem
              {...{
                ...remarkItemProps,
                parentItem,
                week: x,
                year: moment(currentYear).format("YYYY"),
              }}
            >
              {remark && remark.remark_details && (
                <Box sx={{ width: "100%" }} component={"div"}>
                  <Stack direction={"row"} sx={{ justifyContent: "start" }}>
                    <span style={{ fontSize: 12, fontWeight: "bold" }}>
                      Remark:{" "}
                    </span>
                    <span style={{ fontSize: 12, textAlign: "start" }}>
                      {remark.remark_details}
                    </span>
                  </Stack>
                </Box>
              )}
              {x === 0 ? (
                `${parentItem.product_name ? parentItem.product_name : ""} ${
                  parentItem.unit_price ? `($${parentItem.unit_price})` : ""
                }`
              ) : target?.length > 0 ? (
                target?.map((item, index) => (
                  <Stack
                    key={index}
                    sx={{
                      borderBottom: "1px solid black",
                      mb: 1,
                      justifyItems: "center",
                      justifyContent: "space-between",
                    }}
                    direction={"row"}
                  >
                    <Stack
                      sx={{
                        width: "50px",
                        whiteSpace: "wrap",
                      }}
                    >
                      {moment(item.product_discount_startdate).format("DD/MM")}
                      {item.product_discount_startdate ===
                      item.product_discount_enddate
                        ? ""
                        : "-"}
                      {item.product_discount_startdate !==
                        item.product_discount_enddate &&
                        moment(item.product_discount_enddate).format("DD/MM")}
                    </Stack>

                    <Stack
                      sx={{
                        justifyContent: "center",
                        alignItems: "flex-end",
                      }}
                    >
                      <span style={{ color: "red" }}>{item.discount_name}</span>
                      <span>
                        {parseInt(item.product_discount_price)
                          ? `$${item.product_discount_price}`
                          : ""}
                      </span>
                    </Stack>
                  </Stack>
                ))
              ) : (
                <></>
              )}
            </RemarkItem>
          </TableCell>
        );
      })}
    </TableRow>
  );
});
function RemarkItem({ children, ...rest }) {
  const { parentItem, week, year, selectedYear, fetchData } = rest;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [content, setContent] = React.useState("");
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh";
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    updateProducRemark({
      productId: parentItem.product_master_id,
      remarkYear: year,
      remarkWeek: week,
      remarkDetails: content,
    });
    document.body.style.overflow = "scroll";
    document.body.style.height = "auto";
  };

  const updateProducRemark = async (remarkContent) => {
    const startYear = moment(`${selectedYear}-1`, "YYYY-w")
      .startOf("week")
      .format("YYYY-MM-DD");
    const endYear = moment(
      `${selectedYear}-${moment(selectedYear).weeksInYear()}`,
      "YYYY-w"
    );
    try {
      const { results, msg } = await updateProductDiscountRemark({
        ...remarkContent,
        remarkDetails: !remarkContent.remarkDetails ? null : content,
      });
      if (results && msg) {
        fetchData(startYear, endYear);
        setAnchorEl(null);
      }
    } catch (err) {
      console.error(err);
      console.log(err.message);
    }
  };

  return (
    <React.Fragment>
      <Box
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={
          parentItem.id && week > 0 ? (event) => handleClick(event) : () => {}
        }
      >
        {children}
      </Box>
      <Menu
        autoFocus={false}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <FormControl fullWidth>
            <TextField
              variant="standard"
              id="remark"
              name="remark"
              label="Remark"
              type="text"
              multiline
              rows={3}
              onChange={(event) => {
                setContent(event.target.value);
              }}
              value={content}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start"></InputAdornment>
                ),
              }}
            ></TextField>
          </FormControl>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
